export const ACADEMY_MENU_ROUTES = {
  home: '/',
  quickStart: '/quick-start',
  documentation: '/documentation',
  glossary: '/glossary',
  codeSandbox: '/code-sandbox',
} as const
